var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"chevron jam jam-chevron-down",class:{
		'chevron--is-up': _vm.isUp
	},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }